import { render, staticRenderFns } from "./loadeUnloadeOrderAdd.vue?vue&type=template&id=196bc0b0&scoped=true&"
import script from "./loadeUnloadeOrderAdd.vue?vue&type=script&lang=js&"
export * from "./loadeUnloadeOrderAdd.vue?vue&type=script&lang=js&"
import style0 from "./loadeUnloadeOrderAdd.vue?vue&type=style&index=0&id=196bc0b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196bc0b0",
  null
  
)

export default component.exports